module.exports = __webpack_public_path__ + "static/media/sound0.4486a463.mp3";